
import './Admin.scss'; 
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import Login from './login/Login';
import AdminRequireAuth from './AdminRequireAuth';
import Footer from '../components/Footer';
import Backup from './menus/backup/Backup';


export default function AdminMain( props: any) {

  return (
    <div className="AdminContainer">
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/main" element={<AdminRequireAuth><Main/></AdminRequireAuth>}/>
        <Route path="/backup" element={<AdminRequireAuth><Backup/></AdminRequireAuth>}/>
      </Routes>
      <Footer />
    </div>
  );
}
